import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/AuthContext";
import { useCalls } from "@/CallsContext";

function formatDate(value) {
  if (!value) return "—";
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? "—" : d.toLocaleString();
}

function remainingLabel(license) {
  if (!license || license.trial_status !== "active") return "—";
  const secs = Number(license.trial_seconds_remaining) || 0;
  const days = Number(license.trial_days_remaining) || 0;
  const hours = Math.floor((secs % 86400) / 3600);
  if (days > 0) return `${days} day${days === 1 ? "" : "s"} ${hours} hr left`;
  if (secs > 0) return `${hours} hr left`;
  return "Ending soon";
}

function trialStatusLabel(license) {
  const status = license?.trial_status;
  if (status === "active") return "Active trial";
  if (status === "expired") return "Ended";
  return "None";
}

export default function SettingsPage() {
  const { user, logout } = useAuth();
  const { license } = useCalls();
  const navigate = useNavigate();
  const hasAccess = license?.active === true || license?.has_access === true;

  return (
    <div className="mpd-page">
      <div className="mpd-page-head">
        <div>
          <p className="mpd-kicker">Settings</p>
          <h1>Account</h1>
          <p className="mpd-sub">Your MinutePay profile and license. Tracking still runs in the Chrome extension.</p>
        </div>
      </div>
      <article className="mpd-card">
        <h2>Profile</h2>
        <dl className="mpd-dl">
          <div><dt>Name</dt><dd>{user?.full_name || "—"}</dd></div>
          <div><dt>Email</dt><dd>{user?.email}</dd></div>
          <div><dt>Role</dt><dd>{user?.role}</dd></div>
          <div>
            <dt>Access</dt>
            <dd>
              <span className={`mpd-license ${hasAccess ? "is-on" : "is-off"}`}>
                {hasAccess ? "On" : "Off"}
              </span>
            </dd>
          </div>
          <div><dt>Paid license</dt><dd>{license?.license_status || user?.license_status || "—"}</dd></div>
          <div><dt>Blocked</dt><dd>{license?.is_blocked || user?.is_blocked ? "Yes" : "No"}</dd></div>
          <div><dt>Trial</dt><dd>{trialStatusLabel(license || user)}</dd></div>
          <div><dt>Trial started</dt><dd>{formatDate(license?.trial_started_at || user?.trial_started_at)}</dd></div>
          <div><dt>Trial ends</dt><dd>{formatDate(license?.trial_ends_at || user?.trial_ends_at)}</dd></div>
          <div><dt>Time remaining</dt><dd>{remainingLabel(license || user)}</dd></div>
        </dl>
        <Button
          variant="outline"
          onClick={() => {
            logout();
            navigate("/login");
          }}
        >
          Log out
        </Button>
      </article>
    </div>
  );
}
